export const stopTouchEvent = (e) => e && e.stopPropagation();
